export const withSelector = (selector: string) => `&${selector}`;

const notSelector = (selector: string) => `:not(${selector})`;

const classNameSelector = (className: string) =>
  className.startsWith('.') ? className : `.${className}`;

export const withoutClass = (className: string, ...classNames: string[]) => {
  if (classNames.length === 0) {
    return withSelector(notSelector(classNameSelector(className)));
  }
  return withSelector(
    notSelector([className, ...classNames].map(cn => classNameSelector(cn)).join(', ')),
  );
};
